import { clsx } from 'clsx';
import * as React from 'react';
import { SingleSelectItem, ensureChildrenVisibility } from '../../../internal';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function GroupedSelectDesktopOptions(props) {
  var open = props.open,
    indented = props.indented,
    groupIndex = props.groupIndex,
    value = props.value,
    options = props.options,
    focusedIndex = props.focusedIndex,
    actions = props.actions;
  var optionsContainerRef = React.useRef(null);
  var focusedOptionRef = React.useRef(null);
  React.useEffect(function () {
    var optionsContainer = optionsContainerRef.current;
    var focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  var bindHandleOptionClickIndex = function bindHandleOptionClickIndex(index) {
    return function () {
      actions.selectOption({
        group: groupIndex,
        option: index
      });
      actions.closeDropdown();
    };
  };
  var bindHandleOptionMouseMoveIndex = function bindHandleOptionMouseMoveIndex(index) {
    return function () {
      if (focusedIndex.group !== groupIndex || focusedIndex.option !== index) {
        actions.setFocusedIndex({
          group: groupIndex,
          option: index
        });
      }
    };
  };
  return /*#__PURE__*/_jsx("div", {
    ref: optionsContainerRef,
    className: styles['list'],
    children: options.map(function (option, index) {
      var optionValue = option.value;
      var key = String(optionValue);
      var focused = groupIndex === focusedIndex.group && index === focusedIndex.option;
      var selected = value === optionValue;
      return /*#__PURE__*/_jsx("div", {
        ref: focused ? focusedOptionRef : undefined,
        className: clsx(styles['item-wrapper'], focused && styles['focused']),
        onClick: bindHandleOptionClickIndex(index),
        onMouseMove: bindHandleOptionMouseMoveIndex(index),
        role: "option",
        "aria-selected": selected ? 'true' : undefined,
        tabIndex: 0,
        children: /*#__PURE__*/_jsx("div", {
          className: clsx(styles['item'], indented && styles['indented']),
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected
          })
        })
      }, key);
    })
  });
}